import React from 'react';
import { Pagination } from 'react-bootstrap';

// react-bootstrap hardcodes English screen-reader text ("Previous", "Next",
// "(current)") on Pagination.Prev/Next/First/Last and the active item, with no
// prop to change it — so the arrows are built here from plain items instead.
const Arrow = ({ symbol, label, disabled, onClick }) => (
  <Pagination.Item disabled={disabled} onClick={onClick} aria-label={label}>
    <span aria-hidden="true">{symbol}</span>
    <span className="visually-hidden">{label}</span>
  </Pagination.Item>
);

// Page numbers to show: always first, last and the neighbours of the current
// page, with "…" for gaps, so a long list never overflows the row.
function visiblePages(current, total) {
  const keep = new Set([1, total, current - 1, current, current + 1]);
  const pages = [...keep].filter(p => p >= 1 && p <= total).sort((a, b) => a - b);
  const out = [];
  pages.forEach((p, i) => {
    if (i > 0 && p - pages[i - 1] > 1) out.push('gap' + p);
    out.push(p);
  });
  return out;
}

const Pager = ({ page, pages, onChange, showEnds = false }) => (
  <Pagination className="mb-0">
    {showEnds && <Arrow symbol="«" label="Primera página" disabled={page <= 1} onClick={() => onChange(1)} />}
    <Arrow symbol="‹" label="Página anterior" disabled={page <= 1} onClick={() => onChange(page - 1)} />
    {visiblePages(page, pages).map(p => (typeof p === 'string'
      ? <Pagination.Item key={p} disabled>…</Pagination.Item>
      : <Pagination.Item key={p} active={p === page} activeLabel="(actual)" onClick={() => onChange(p)}>{p}</Pagination.Item>))}
    <Arrow symbol="›" label="Página siguiente" disabled={page >= pages} onClick={() => onChange(page + 1)} />
    {showEnds && <Arrow symbol="»" label="Última página" disabled={page >= pages} onClick={() => onChange(pages)} />}
  </Pagination>
);

export default Pager;
